import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { RcTitleStrategy } from './rc-title.strategy';
import { PageTitleService } from './page-title.service';
import { APP_TITLE_SUFFIX } from '../config';
import { CapitalizePipe } from '../pipes';

/**
 * Drives the browser tab title from the activated route's `title` translation key, letting
 * detail pages override it through `DetailTitleService`.
 *
 * @param suffix brand appended after the page name, e.g. `Ontvangsten | CrownBase`.
 */
export function providePageTitle(suffix: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    CapitalizePipe,
    { provide: APP_TITLE_SUFFIX, useValue: suffix },
    { provide: TitleStrategy, useClass: RcTitleStrategy },
    // The service owns the effect that writes the title, so it has to exist before the first
    // navigation rather than waiting for something to inject it.
    provideAppInitializer(() => void inject(PageTitleService)),
  ]);
}
